import React, { useEffect, useMemo, useState } from 'react';
import AdminLayoutWrapper from '../AdminLayoutWrapper';
import { listTeamMembers } from '../../../apis/teams';
import { Button, Table, Breadcrumb, Card } from 'antd';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router';
import { PlusCircleOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';

const columns = [
  {
    title: 'Name',
    dataIndex: 'user',
    render: (value) => {
      return (
        <div>{value.name}</div>
      )
    }
  }, {
    title: 'Role',
    dataIndex: 'role',
    render: (value) => {
      return (
        <div>{value}</div>
      )
    }
  }
]

const style = {
  tableToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0px',
    alignItems: 'center'
  }
}

const ListTeamUsers = ({ user }) => {
  const [teamMembers, setTeamMembers] = useState([]);

  const { id } = useParams();

  const isAdmin = (user && user.admin) || false;

  useEffect(() => {
    const fetchTeamServices = async () => {
      const data = await listTeamMembers(id);
      setTeamMembers(data);
    }
    fetchTeamServices();
  }, [id])

  const isTeamAdmin = useMemo(() => {
    const currentUserId = (user && user.id) || null;

    if (currentUserId && teamMembers) {
      const findCurrentUser = teamMembers.find((member) => {
        return ((member.user.id).toString() === currentUserId.toString() && member.role === "team_admin");
      });

      if (findCurrentUser) {
        return true
      }
    }
    return false;
  }, [teamMembers, user])

  return (
    <AdminLayoutWrapper>
      <div style={{ padding: '0px 0px 16px 0px' }}>
        <Breadcrumb>
          <Breadcrumb.Item>Home</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/admin/teams/me`}>Manage Team</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            Team Members
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Card>
        <div style={style.tableToolbar}>
          {
            (!isAdmin && !isTeamAdmin) && <h3><b>List Team Members</b></h3>
          }
          {
            (isAdmin || isTeamAdmin) && (<>
              <h3><b>List Team Members</b></h3>
              <div>
                <Link to={`/admin/teams/${id}/members/assign`}>
                  <Button type="primary">Assign Members <PlusCircleOutlined /></Button>
                </Link>
              </div>
            </>)
          }
        </div>
        <div>
          <Table
            dataSource={teamMembers}
            columns={columns}
          />
        </div>
      </Card>
    </AdminLayoutWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.app.user
  }
}

export default connect(mapStateToProps)(ListTeamUsers);
